import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ProposalLetterSection = ({ proposalLetter, highlight = false }) => {
  const intl = useIntl();
  if (!proposalLetter) {
    return null;
  }

  return (
    <div className={`bg-succession-bg-secondary rounded-lg border ${highlight ? 'border-succession-primary ring-2 ring-succession-primary/20' : 'border-succession-border'} overflow-hidden transition-all duration-300`}>
      {/* Header */}
      <div className={`px-6 py-4 border-b ${highlight ? 'border-succession-primary bg-succession-primary/5' : 'border-succession-border'}`}>
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <svg className={`w-6 h-6 ${highlight ? 'text-succession-primary' : 'text-succession-text-muted'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-succession-text-primary">
              {intl.formatMessage({ id: 'succession.profile_drawer.proposal_letter_section.advisor_proposal_letter' })}
            </h3>
            <p className="text-sm text-succession-text-muted mt-1">
              {intl.formatMessage({ id: 'succession.profile_drawer.proposal_letter_section.initial_proposal' })}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6">
        <div className={`text-sm text-succession-text-primary leading-relaxed whitespace-pre-wrap bg-succession-bg-primary rounded-lg p-5 border ${highlight ? 'border-succession-primary/30' : 'border-succession-border'}`}>
          {proposalLetter}
        </div>
      </div>

      {/* Footer - only show if highlighted */}
      {highlight && (
        <div className="px-6 py-3 bg-succession-primary/5 border-t border-succession-primary/20">
          <div className="flex items-center text-xs text-succession-primary font-medium">
            <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {intl.formatMessage({ id: 'succession.profile_drawer.proposal_letter_section.review_carefully' })}
          </div>
        </div>
      )}
    </div>
  );
};

ProposalLetterSection.propTypes = {
  proposalLetter: PropTypes.string,
  highlight: PropTypes.bool,
};

export default ProposalLetterSection;

